// extracted by mini-css-extract-plugin
module.exports = {"wideBanner":"WideBanner_wideBanner__2_f32"};